<template>
  <section>
    <div class="container is-fluid">
      <div class="columns is-multiline">
        <div
          class="column is-one-third"
          v-for="connection in $store.state.property.connections"
          :key="connection.id"
        >
          <div class="card moveable-card">
            <div class="card-content">
              <div class="has-text-weight-semibold">{{ connection.type }}</div>
              <div class="">{{ connection.name }}</div>
              <div class="">{{ connection.phone }}</div>
              <div class="">{{ connection.email }}</div>

              <div class="is-size-7">{{ connection.createdUtc | fromNow }}</div>
              <div class="level-left">
                <div class="level-item">
                  <span class="icon">
                    <b-tooltip
                      label="Remove"
                      position="is-bottom"
                    >
                      <a
                        class="fas fa-trash"
                        @click="deleteConnection(connection)"
                      ></a>
                    </b-tooltip>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import store from "@/store";

export default {
  props: {
    note: Object
  },
  methods: {
    deleteConnection(connection) {
      this.$buefy.dialog.confirm({
        title: "Remove connection",
        message: `<b>Remove connection from property?</b><br><br>${
          connection.name
        }`,
        confirmText: "Remove connection",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          var property = store.state.property;
          store.dispatch("deletePropertyConnection", {
            property,
            connection
          });
          this.$buefy.toast.open({
            message: "Connection removed",
            type: "is-success",
            duration: 3000
          });
        }
      });
    }
  }
};
</script>

<style>
</style>
